import PageHeadingWithTrialProgress from '../dashboard/PageHeadingWithTrialProgress';

const ApiKeyListHeader = () => {
  return (
    <PageHeadingWithTrialProgress
      title="Developer tools"
      titleProps={{ mr: 2 }}
    />
  );
};
export default ApiKeyListHeader;
